define('constants/liveReceptionistOnboardingStatusConstants',[], function() {
    return {
        'pending': 0,
        'initiated': 1,
        'inProgress': 2,
        'validated': 3,
        'scriptCreationFailed': 4,
        'scriptCreationSucceeded': 5,
        'accountOnboardingPending': 6,
        'accountOnboardingInProgress': 7,
        'accountOnboardingCompleted': 8,
        'accountOnboardingFailedRetryQueued': 9,
        'accountOnboardingFailed': 10
    };
});
